var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11433 755 28.429 28.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a1e1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11433 755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.214,0A14.214,14.214,0,1,0,28.429,14.214,14.228,14.228,0,0,0,14.214,0Zm0,26.892A12.679,12.679,0,1,1,26.892,14.214,12.635,12.635,0,0,1,14.214,26.892Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M69.973,80.737A1.537,1.537,0,1,1,68.437,79.2a1.532,1.532,0,0,1,1.537,1.537Zm0,0",
    transform: "translate(-58.868 -69.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M149.173,80.737a1.537,1.537,0,1,1-1.537-1.537,1.532,1.532,0,0,1,1.537,1.537Zm0,0",
    transform: "translate(-128.56 -69.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M63.955,143.4a8.93,8.93,0,0,0-7.455,4.046l1.3.828a7.317,7.317,0,0,1,12.281,0l1.3-.828a8.929,8.929,0,0,0-6.4-3.986,7.492,7.492,0,0,0-1.02-.06Zm0,0",
    transform: "translate(-49.717 -126.184)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadIcon);
export default __webpack_public_path__ + "static/media/sad_icon.bd198461140c76a8250eefe8c84d35a0.svg";
export { ForwardRef as ReactComponent };